import { useParams } from "react-router-dom";
import { useStockNews } from "../../../../../../../../api/services/financial-integration.hooks";
import {
  ListTable,
  type ListTableItem,
} from "../../../../../../../../components/ListTable";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

// Функция для форматирования даты
const formatDate = (dateString: string): string => {
  const date = dayjs(dateString);
  const now = dayjs();
  const diffDays = now.diff(date, "day");

  if (diffDays === 0) {
    return "Today";
  } else if (diffDays === 1) {
    return "Yesterday";
  } else if (diffDays < 7) {
    return date.format("ddd, MMM DD");
  } else {
    return date.format("MMM DD, YYYY");
  }
};

export const AmznNews = () => {
  const { symbol } = useParams();

  const { data: newsResponse, isLoading } = useStockNews({
    symbols: symbol || "",
    page: 0,
    limit: 10,
  });

  const newsItems: ListTableItem[] =
    newsResponse?.data?.map((item, index) => ({
      id: item.url || `news-${index}`,
      title: item.title,
      publisher: item.publisher,
      publishedDate: item.publishedDate,
      date: formatDate(item.publishedDate),
      source: item.site || item.publisher,
      image: item.image,
      url: item.url,
      text: item.text,
    })) || [];

  const handleViewAll = () => {
    // TODO: Navigate to full news page
  };

  if (isLoading) {
    return (
      <ListTable
        title={`${symbol || ""} News`}
        items={[]}
        showViewAll={false}
      />
    );
  }

  if (!newsResponse?.data || newsItems.length === 0) {
    return (
      <ListTable
        title={`${symbol || ""} News`}
        items={[]}
        showViewAll={false}
      />
    );
  }

  return (
    <ListTable
      title={`${symbol || ""} News`}
      items={newsItems}
      onViewAll={handleViewAll}
      showViewAll={true}
    />
  );
};
